export default __webpack_public_path__ + "static/media/area-67.2cecb480.jpg";